import Add from './icons/Add';
import Electricity from './icons/Electricity';
import Layout from './icons/Layout';
import NaturalGas from './icons/NaturalGas';
import Settings from './icons/Settings';

export {Add, Electricity, Layout, NaturalGas, Settings};
